import Modal from "../UI/Modal";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { closeViewModal } from "../../store/reducers/schools/schools.reducer";
import Loader from "../UI/Loader";
import Field from "../UI/Field";
import AuditInfo from "../UI/AuditInfo";

const SchoolViewModal = () => {
  const dispatch = useDispatch();

  const {
    viewModalOpen,
    selectedSchool,
    selectedSchoolLoading,
    selectedSchoolError,
  } = useSelector((state) => state.schools);

  return (
    <Modal
      open={viewModalOpen}
      onClose={() => dispatch(closeViewModal())}
      title="Detalle de la escuela"
      size="lg"
    >
      {selectedSchoolLoading && (
        <Loader center text="Cargando información de la escuela..." delay={150} type="dots" />
      )}

      {selectedSchoolError && (
        <p className="text-danger">{selectedSchoolError}</p>
      )}

      {!selectedSchoolLoading && selectedSchool && (
        <div className="row g-4">
          {/* Columna Izquierda */}
          <div className="col-md-6">
            <div className="d-flex flex-column gap-3">
              <Field
                icon="mdi:school-outline"
                label="Nombre"
                value={selectedSchool.nombre}
              />
              <Field
                icon="mdi:alphabetical"
                label="Siglas"
                value={selectedSchool.siglas}
              />
            </div>
          </div>

          {/* Columna Derecha */}
          <div className="col-md-6">
            <div className="d-flex flex-column gap-3">
              <Field
                icon="mdi:format-list-bulleted-type"
                label="Tipo"
                value={selectedSchool.tipo}
              />
              <Field
                icon="mdi:office-building-outline"
                label="Modalidad"
                value={selectedSchool.publica ? "Pública" : "Privada"}
              />
            </div>
          </div>

          {/* Información de auditoría */}
          <div className="col-12">
            <AuditInfo
              createdAt={selectedSchool.created_at}
              updatedAt={selectedSchool.updated_at}
              createdBy={selectedSchool.created_by}
              updatedBy={selectedSchool.updated_by}
            />
          </div>
        </div>
      )}
    </Modal>
  );
};

export default SchoolViewModal;
